export default "__VITE_ASSET__CR5h35RB__"